import { AppProvider } from 'providers';
import { AppRoutes } from 'routes';
import { WidgetProvider } from '@telescope/cassini-hooks';

export const App = () => {
  return (
    <WidgetProvider pollingRate={5000}>
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </WidgetProvider>
  )
}
